module.exports = __webpack_public_path__ + "img/banner-international-truck.b650b755.png";